import md5 from 'js-md5'
import ElementUI from 'element-ui'
import moment from 'moment'

let fileType = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'audio/mp3': '.mp3',
  'video/mpeg4': '.mp4',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/x-ppt': '.ppt',
  'text/plain': '.txt',
  'application/vnd.ms-excel': '.xls',
  'application/x-xls': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xls',
  'text/xml': '.xml',
  'application/msword': '.doc',
  'video/avi': '.avi',
  'application/x-msdownload': '.exe',
  'text/html': '.html',
  'application/x-jpg': '.jpg',
  'application/x-javascript': '.js',
  'application/x-png': '.png',
  'application/json': 'json',
  'application/vnd.adobe.workflow': '.awf'
}


export default {
  cacheMap: {},
  getStorage (key) {
    let obj = {}
    if (window.localStorage.getItem(key)) {
      obj = JSON.parse(window.localStorage.getItem(key))
      if (this.isNull(obj)) {
        obj = {}
      }
    }
    return obj
  },
  async getStorageSync (key, callback) {
    let obj = this.cacheMap[key]
    if (this.isNull(obj) && callback && typeof callback === 'function') {
      obj = await callback()
      this.cacheMap[key] = obj
    }
    return obj
  },
  setStorage (key, val) {
    let res = window.localStorage.setItem(key, JSON.stringify(val))
    return res
  },
  generate (password, salt) {
    let md5Str = md5.base64(password + salt)
    return md5Str
  },
  md5Str (obj) {
    let md5Str = md5.hex(obj)
    return md5Str
  },
  randomn (n) {
    if (n > 21) {
      return null
    }
    let r = (Math.random() + 1) * Math.pow(10, n - 1)
    return parseInt(r)
  },
  debounce (id, callback, delay = 500) {
    let inputing = 'inputing-' + id
    let timeout = 'timeout-' + id
    this[inputing] = true
    if (this[timeout]) {
      clearTimeout(this[timeout])
    }
    this[timeout] = setTimeout(async () => {
      if (this[inputing]) {
        await callback()
        this[inputing] = false
      }
    }, delay)
  },
  windowResizeEvent (callback) {
    setTimeout(async () => {
      await callback()
    }, 100)
    window.addEventListener('resize', () => {
      this.debounce('resizeFlag', callback, 100)
    }, false)
  },
  getClientHeight () {
    let clientHeight = 0
    if (document.body.clientHeight && document.documentElement.clientHeight) {
      clientHeight = document.body.clientHeight < document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight
    } else {
      clientHeight = document.body.clientHeight > document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight
    }
    return clientHeight
  },
  calcTableHeight (pageDom) {
    if (pageDom && pageDom.getBoundingClientRect()) {
      return this.getClientHeight() - pageDom.getBoundingClientRect().top - 92
    } else {
      return 200
    }
  },
  fixNumber (value, max, dot) {
    value = value + ''
    if (!value) {
      return value
    } else {
      if ((Number(value) > max)) {
        value = value.replace(/.$/, '')
        this.debounce('checkNumber', () => {
          ElementUI.Message({ type: 'error', message: '请输入' + max + '以内的数值' })
        })
        return this.fixNumber(value, max, dot)
      }
      if (dot > 0) {
        let reg = /^(0|[1-9]\d*)($|\.\d{0,2}$)/
        if (reg.test(value)) {
          return value
        } else {
          value = value.replace(/.$/, '')
          this.debounce('checkNumber', () => {
            ElementUI.Message({ type: 'error', message: '请输入合法的' + dot + '位以内小数' })
          })
          return this.fixNumber(value, max, dot)
        }
      }
      return value
    }
  },
  checkNumber (value, max, dot = 0) {
    value = (value + '').replace(/。/g, '.').replace(/[^\d\\.]/g, '')
    if (max > 0 || dot > 0) {
      value = this.fixNumber(value, max, dot)
    } else {
      value = (value + '').replace(/[^\d]/g, '')
    }
    return value
  },
  checkIP (e) {
    let value = e.replace(/[^0-9.]/g, '')
    return value
  },
  find (list, key = 'id', val = 'name', value = 0) {
    for (let i in list) {
      if (list[i][key] === value) {
        if (val) {
          return list[i][val]
        } else {
          return list[i]
        }
      }
    }
    return ''
  },
  toTree (data = [], key = 'id', pKey = 'parentId', pid = null, childKey = 'children') {
    let tree = []
    let temp
    for (let i in data) {
      if (data[i][pKey] === pid) {
        let obj = data[i]
        temp = this.toTree(data, key, pKey, data[i][key], childKey)
        if (temp.length > 0) {
          if (this.isNull(obj[childKey])) {
            obj[childKey] = temp
          } else {
            obj[childKey] = [...obj[childKey], ...temp]
          }
        }
        tree.push(obj)
      }
    }
    return tree
  },
  findTree (tree, key = 'id', val = 'name', value = 0, children = 'children') {
    let res = this.find(tree, key, val, value)
    if (res === '') {
      for (let i in tree) {
        let list = tree[i][children]
        let treeRes = this.findTree(list, key, val, value, children)
        if (treeRes !== '') {
          return treeRes
        }
      }
      return ''
    } else {
      return res
    }
  },
  walkTree (tree, callback) {
    for (let i in tree) {
      let node = tree[i]
      node.index = Number(i)
      callback(node)
      if (node.children && node.children.length) {
        this.walkTree(node.children, callback)
      }
    }
  },
  getTreeIds (treeDom, treeKey) {
    let checkedNodes = treeDom.getCheckedNodes(true, false)
    let ids = []
    for (let i in checkedNodes) {
      ids.push(checkedNodes[i][treeKey])
    }
    return ids
  },
  getFileName (url = '') {
    if (!url) {
      url = ''
    }
    let str = url.split('?')[0]
    return str.substring(str.lastIndexOf('/') + 1)
  },
  getImageSize (file) {
    return new Promise((resolve, reject) => {
      let reader = new window.FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        let url = e.target.result
        let img = new window.Image()
        img.src = url
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (err) => {
          reject(err)
        }
      }
      reader.onerror = (err) => {
        reject(err)
      }
    })
  },
  limitDateTime (startTime, endTime, limitMaxStartTime = moment(), limitMaxEndTime = '3000-01-01 00:00:00', limitMinStartTime = null, limitMinEndTime = null) {
    if (limitMinStartTime && limitMinEndTime) {
      let limit1 = moment(startTime).isSameOrAfter(moment(limitMaxStartTime)) && moment(startTime).isSameOrBefore(moment(limitMinStartTime))
      let limit2 = moment(endTime).isSameOrAfter(moment(limitMinEndTime)) && moment(endTime).isSameOrBefore(moment(limitMaxEndTime))
      if (limit1 && limit2) {
        return true
      }
    } else {
      return moment(startTime).isSameOrAfter(limitMaxStartTime) && moment(endTime).isSameOrBefore(limitMaxEndTime)
    }
  },
  limitDate (currTime, limitStartTime = moment(), limitEndTime = '3000-01-01 00:00:00') {
    let limit = moment(currTime).isSameOrAfter(moment(limitStartTime).add(-1, 'day')) && moment(currTime).isSameOrBefore(moment(limitEndTime).add(1, 'day'))
    return limit
  },
  getMinDateTime (time1, time2) {
    if (time1 && time2) {
      if (moment(time1).isBefore(time2)) {
        return time1
      } else {
        return time2
      }
    } else {
      return time1 || time2
    }
  },
  convertCondition (queryParam = {}) {
    let pageNum = queryParam.pageNum || 1
    let pageSize = queryParam.pageSize || 20
    let orderBy = queryParam.orderBy || false
    delete queryParam.pageNum
    delete queryParam.pageSize
    delete queryParam.orderBy
    let conditionList = []
    queryParam = JSON.parse(JSON.stringify(queryParam))
    for (let key in queryParam) {
      let value = queryParam[key]
      if (value !== undefined && value !== null && value !== '') {
        if (value instanceof Array) {
          let oper = 'in'
          let arr = []
          for (let index in value) {
            if (value[index] !== undefined && value[index] != null && value[index] !== '') {
              if (value[index] instanceof moment) {
                oper = 'between'
                arr.push(value[index].format('YYYY-MM-DD HH:mm:ss'))
              }
              if (typeof value[index] === 'number') {
                oper = 'between'
                arr.push(Number(value[index]))
              } else {
                arr.push(value[index])
              }
            }
          }
          if (arr.length === 2) {
            if (oper === 'between') {
              let condition = { name: key, oper: 'between', value: arr[0], betweenValue: arr[1] }
              conditionList.push(condition)
            } else {
              let condition = { name: key, oper: 'in', inValues: arr }
              conditionList.push(condition)
            }
          } else if (arr.length > 0) {
            let condition = { name: key, oper: 'in', inValues: arr }
            conditionList.push(condition)
          }
        } else {
          let condition = { name: key, oper: '=', value: value }
          conditionList.push(condition)
        }
      }
    }
    let condition = {
      pageSize: pageSize,
      pageNum: pageNum
    }
    if (!this.isNull(conditionList)) {
      condition.conditionList = conditionList
    }
    if (orderBy) {
      condition.orderBy = orderBy
    }
    return condition
  },
  values (list, key, val, value) {
    let res = []
    for (let i in list) {
      if (list[i][key] === value) {
        res.push(list[i][val])
      }
    }
    return res
  },
  joinList (list, col, sp = false) {
    let arr = []
    for (let i in list) {
      arr.push(list[i][col])
    }
    if (sp === false) {
      return arr
    } else {
      return arr.join(sp)
    }
  },
  isIP (str) {
    return /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(str)
  },
  isArray (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  },
  isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
  },
  log (...arr) {
    console.log(arr)
  },
  /**
   * 秒数格式化
   * @param duration 秒数
   * @param fmt Y年M个月D天H小时m分钟s秒
   * @returns {string}
   */
  formatDuration (duration, fmt = 'Y年M个月D天H小时m分钟s秒') {
    let ms = 60
    let Hs = ms * 60
    let Ds = Hs * 12
    let Ms = Ds * 30
    let Ys = Ms * 12

    let Y = Math.floor(duration / Ys)
    let M = Math.floor((duration - Y * Ys) / Ms)
    let D = Math.floor((duration - Y * Ys - M * Ms) / Ds)

    let H = Math.floor((duration - Y * Ys - M * Ms - D * Ds) / Hs)
    let m = Math.floor((duration - Y * Ys - M * Ms - D * Ds - H * Hs) / ms)
    let s = Math.floor(duration - Y * Ys - M * Ms - D * Ds - H * Hs - m * ms)
    let obj = { 'Y+': Y, 'M+': M, 'D+': D, 'H+': H, 'm+': m, 's+': s }
    for (let k in obj) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (obj[k]) : (('00' + obj[k]).substr(('' + obj[k]).length)))
      }
    }
    return fmt
  },
  isNull (obj) {
    if (obj === undefined) {
      return true
    } else if (obj === null) {
      return true
    } else if (obj === '') {
      return true
    } else if (this.isArray(obj) && obj.length === 0) {
      return true
    } else if (this.isObject(obj) && JSON.stringify(obj) === '{}') {
      return true
    } else {
      return false
    }
  },
  toChinese (num) {
    let arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
    if (num <= 10) {
      return arr[num]
    }
    return num
  },
  map2arr (map) {
    let arr = []
    for (let i in map) {
      arr.push({ key: Number(i), value: map[i] })
    }
    return arr
  },
  filter (list, param) {
    let arr = []
    for (let i in list) {
      let item = list[i]
      let isOk = true
      for (let key in param) {
        if (this.isNull(item[key]) && !this.isNull(param[key])) {
          isOk = false
          continue
        }
        if (this.isArray(param[key])) {
          if (param[key].length === 2) {
            if (param[key][0] instanceof moment) {
              if (moment(item[key]).isSameOrAfter(param[key][0]) && moment(item[key]).isSameOrBefore(param[key][1])) {

              } else {
                isOk = false
                continue
              }
            } else if (typeof param[key][0] === 'number') {
              if (param[key][0] < Number(item[key]) && Number(item[key]) <= param[key][1]) {

              } else if (Number(param[key][0]) === 0 && Number(item[key]) === 0) {

              } else {
                isOk = false
                continue
              }
            } else {
              if (param[key].indexOf(item[key]) === -1) {
                isOk = false
                continue
              }
            }
          } else {
            if (param[key].indexOf(item[key]) === -1) {
              isOk = false
              continue
            }
          }
        } else if (this.isObject(param[key])) {
          isOk = false
          continue
        } else {
          if (param[key] + '' !== item[key] + '') {
            isOk = false
            continue
          }
        }
      }
      if (isOk) {
        arr.push(item)
      }
    }
    return arr
  },
  checkForm (form, fields = []) {
    return new Promise((resolve, reject) => {
      if (form && form.validate && form.validateField) {
        let res = true
        if (this.isNull(fields)) {
          form.validate((val) => {
            res = val
          })
        } else {
          let checkFields = []
          if (typeof fields === 'string') {
            for (let i in form.fields) {
              let field = form.fields[i]
              if (field && field.prop && field.prop.includes(fields)) {
                checkFields.push(field.prop)
              }
            }
          } else {
            checkFields = fields
          }
          form.validateField(checkFields, (err) => {
            if (err) {
              res = false
            }
          })
        }
        if (res) {
          resolve(res)
        } else {
          reject(new Error())
        }
      } else {
        reject(new Error('表单参数不正确'))
      }
    })
  },
  doError (e) {
    if (e && e.message && /^.*[\u4E00-\u9FA5]+.*$/.test(e.message)) {
      ElementUI.Message({ type: 'error', message: e.message })
      if (e.message === '请重新登录' || e.message === '请登录') {
        window.location.href = '?#/index/login'
      }
    } else if (e && e.message === 'Network Error') {
      ElementUI.Message({ type: 'error', message: '连接失败' })
    } else if (e && e.message && e.message.indexOf('timeout of') > -1) {
      ElementUI.Message({ type: 'error', message: '连接超时' })
    } else {
      if (['dev', 'test'].indexOf(process.env.BABEL_ENV) > -1) {
        console.error('doError', e)
        if (e.message) {
          ElementUI.Message({ type: 'error', message: e.message })
        }
      }
    }
  },
  downloadFile (fileUrl, fileName) {
    fileUrl = fileUrl.replace(/\\/g, '/')
    let link = document.createElement('a')
    link.href = fileUrl
    link.download = fileName || fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
    link.click()
  },
  isAllowBrowser () {
    // 获取UserAgent属性
    let allowBrowser = ['Chrome', 'Safari']
    let type = navigator.userAgent
    for (let i in allowBrowser) {
      if (type.indexOf(allowBrowser[i]) > -1) {
        return true
      }
    }
    return false
  },
  isMobile () {
    let userAgentInfo = navigator.userAgent
    let agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
    for (let v = 0; v < agents.length; v++) {
      if (userAgentInfo.includes(agents[v])) {
        return true
      }
    }
    return false
  },
  checkBrowser () {
    let flag = false
    if (this.isAllowBrowser()) {
      if (!this.isMobile()) {
        flag = true
      }
    }
    if (!flag) {
      ElementUI.MessageBox.confirm(`为了能够更好的体验系统功能，我们建议您使用最新的谷歌或苹果的PC浏览器(或chrome及Safari内核浏览器的极速模式)进行访问。`, '您的浏览器版本过低。', {
        showConfirmButton: false,
        showCancelButton: false,
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'width-auto'
      })
    }
    return flag
  },
  doDropList (drop, dropIds = [], key = 'value') {
    let list = drop.list
    let freeNum = 0
    for (let i in list) {
      if (dropIds.includes(list[i][key])) {
        list[i].disabled = true
      } else {
        list[i].disabled = false
        freeNum++
      }
    }
    return { freeNum: freeNum, list: list }
  },
  doDropTree (drop, dropIds = [], key = 'value') {
    let tree = drop.tree
    let freeNum = 0
    this.walkTree(tree, (node) => {
      if (dropIds.includes(node[key])) {
        node.disabled = true
      } else if (this.isNull(node.children)) {
        node.disabled = false
        freeNum++
      } else {
        node.disabled = false
      }
    })
    return { freeNum: freeNum, tree: tree }
  },
  _toFixed (num, n = 0) {
    return Number(Number(Number(num).toFixed(10)).toFixed(n))
  },
  /**
   * 深度拷贝对象
   * @param {Object} sourece 拷贝源对象
   * @param {Object} target 目标对象
   */
  deepCopy (sourece, target) {
    target = target || {}
    for (let item in sourece) {
      if (typeof sourece[item] === 'object' && sourece[item] !== null) {
        target[item] = (sourece[item].constructor === Array) ? [] : {};
        this.deepCopy(sourece[item], target[item]);
      } else {
        target[item] = sourece[item];
      }
    }
    return target;
  },

  /*base64旋转图片*/
  rotateBase64Img (src, edg, callback) {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var imgW;//图片宽度
    var imgH;//图片高度
    var size;//canvas初始大小

    if (edg % 90 != 0) {
      console.error("旋转角度必须是90的倍数!");
      throw '旋转角度必须是90的倍数!';
    }
    (edg < 0) && (edg = (edg % 360) + 360)
    const quadrant = (edg / 90) % 4; //旋转象限
    const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标

    var image = new Image();
    image.crossOrigin = "anonymous"
    image.src = src;

    image.onload = function () {

      imgW = image.width;
      imgH = image.height;
      size = imgW > imgH ? imgW : imgH;

      canvas.width = size * 2;
      canvas.height = size * 2;
      switch (quadrant) {
        case 0:
          cutCoor.sx = size;
          cutCoor.sy = size;
          cutCoor.ex = size + imgW;
          cutCoor.ey = size + imgH;
          break;
        case 1:
          cutCoor.sx = size - imgH;
          cutCoor.sy = size;
          cutCoor.ex = size;
          cutCoor.ey = size + imgW;
          break;
        case 2:
          cutCoor.sx = size - imgW;
          cutCoor.sy = size - imgH;
          cutCoor.ex = size;
          cutCoor.ey = size;
          break;
        case 3:
          cutCoor.sx = size;
          cutCoor.sy = size - imgW;
          cutCoor.ex = size + imgH;
          cutCoor.ey = size + imgW;
          break;
      }

      ctx.translate(size, size);
      ctx.rotate(edg * Math.PI / 180);
      ctx.drawImage(image, 0, 0);

      var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
      if (quadrant % 2 == 0) {
        canvas.width = imgW;
        canvas.height = imgH;
      } else {
        canvas.width = imgH;
        canvas.height = imgW;
      }
      ctx.putImageData(imgData, 0, 0);
      callback(canvas.toDataURL())
    };
  },
  base64ToFile (base64, name) {
    let arr = base64.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let fix = fileType[mime]
    let bstr = window.atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new window.File([u8arr], name + '-' + Date.now() + fix, { type: mime })
  }
}
